/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{z as e,A as r}from"./SpatialReference.js";class t extends e{getOperatorType(){return 5}execute(e,t,a,s){return r(e,t,a,8,s)}}export{t as O};
